import { createContext, useContext } from "react";
import { useRegion } from "./RegionContext";
import { translations } from "./translations";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const { language, direction } = useRegion();

  const dict = translations[language] || translations.en;

  // Returns the translated string for a key, falling back to the key itself.
  const t = (key) => dict[key] ?? translations.en[key] ?? key;

  // Arabic-localized product gallery for Middle East visitors.
  const arabicGallery = [
    "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/de52380ab_1.jpg",
    "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/a28dddb27_2.jpg",
    "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/b0655caf3_3.jpg",
    "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/d7672a249_4.jpg",
    "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/fe156cf22_5.jpg",
    "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/05a3379aa_6.jpg",
    "https://media.base44.com/images/public/68e21bb4c1e25d4ab005735e/79804181c_7.jpg",
  ];

  // English product gallery for non-Middle East visitors.
  // The English "TRUNK-FRIENDLY DESIGN" marketing infographic was removed to keep the gallery clean.
  const englishGallery = [
    "https://res.cloudinary.com/dilx8zm2p/image/upload/f_auto,q_30,w_800/v1759783025/1_iatrwm.jpg",
    "https://res.cloudinary.com/dilx8zm2p/image/upload/f_auto,q_30,w_800/v1759783027/3_dsotbs.jpg",
    "https://res.cloudinary.com/dilx8zm2p/image/upload/f_auto,q_30,w_800/v1759783029/5_gjicgv.jpg",
    "https://res.cloudinary.com/dilx8zm2p/image/upload/f_auto,q_30,w_800/v1759783030/6_zril2w.jpg",
    "https://res.cloudinary.com/dilx8zm2p/image/upload/f_auto,q_30,w_800/v1759783030/7_cn0emj.jpg",
    "https://res.cloudinary.com/dilx8zm2p/image/upload/f_auto,q_30,w_800/v1759783025/%E7%94%BB%E6%9D%BF_2_twgryo.jpg",
  ];

  const getProductImages = () => {
    const gallery = language === "ar" ? arabicGallery : englishGallery;
    return {
      hero: gallery[0],
      gallery,
    };
  };

  return (
    <LanguageContext.Provider
      value={{ language, direction, t, getProductImages }}
    >
      {children}
    </LanguageContext.Provider>
  );
}